import { getRegionUrl } from '../../helpers/urls';
import { GetFishingWater_fishingWater_intersectingCounties_edges_node } from '../../interfaces/graphql';
import { getUniqueCountiesByRegion } from './helpers/getUniqueCountiesByRegion';

interface IProps {
  regionId?: string | null;
  regionName?: string | null;
  countyName?: string;
  intersectingCounties: GetFishingWater_fishingWater_intersectingCounties_edges_node[];
}

export const getIntersectingCountiesLinksString = ({
  regionId,
  regionName,
  countyName,
  intersectingCounties,
}: IProps) => {
  if (!regionId || !regionName || !countyName) {
    return '';
  }
  const uniqueCountiesByRegion = getUniqueCountiesByRegion(
    countyName,
    regionId,
    intersectingCounties,
  );

  if (uniqueCountiesByRegion.length === 0) {
    return '';
  }

  return uniqueCountiesByRegion
    .flatMap(({ name, region, country }) => {
      if (!region.regionCode || !region.name || !name) {
        return [];
      }
      return `${name}, <a href="${getRegionUrl(country.id, region.regionCode, country.countryName, region.name)}">${region.name}</a>`;
    })
    .join(', ');
};
